<template>
  <div class="moduleStyle minHeight">
    <pageTitle title="采购单">
      <template v-if="hasPermission('采购-采购单-新增')">
        <el-button
          size="small"
          icon="el-icon-plus"
          type="primary"
          @click="newlyAdded"
          >新增采购单</el-button
        >
      </template>
    </pageTitle>
    <basicList
      :config="basicListconfig"
      @sortChange="sortChange"
      @search="searchEvent"
    >
      <template v-slot:additionalFeatures>
        <div class="procurementDataSummary procurementDataSummary2">
          <ul>
            <li>
              <div>
                <div class="summaryTitle">今日采购</div>
                <div class="today summaryLine">
                  <p>¥{{ summarizeData.daily_total_money | money }}</p>
                </div>
              </div>
              <div class="subtotals">
                <p>采购量：{{ summarizeData.daily_num }} 瓶</p>
                <p>未结：¥{{ summarizeData.daily_last_money | money }}</p>
              </div>
            </li>
            <li>
              <div>
                <div class="summaryTitle">昨日采购</div>
                <div class="yesterday summaryLine">
                  <p>¥{{ summarizeData.yesterday_total_money | money }}</p>
                </div>
              </div>
              <div class="subtotals">
                <p>采购量：{{ summarizeData.yesterday_num }} 瓶</p>
                <p>未结：¥{{ summarizeData.yesterday_last_money | money }}</p>
              </div>
            </li>
            <!-- <li>
              <div>
                <div class="summaryTitle">十日采购</div>
                <div class="summaryLine">
                  <p>¥{{ summarizeData.tendays_total_money | money }}</p>
                </div>
              </div>
              <div class="subtotals">
                <p>采购量：{{ summarizeData.tendays_num }} 瓶</p>
                <p>未结：¥{{ summarizeData.tendays_last_money | money }}</p>
              </div>
            </li> -->
            <li>
              <div>
                <div class="summaryTitle">查询汇总</div>
                <div class="summaryLine">
                  <p>¥{{ summarizeData.total_money | money }}</p>
                </div>
              </div>
              <div class="subtotals">
                <p>采购量：{{ summarizeData.num }} 瓶</p>
                <p>未结：¥{{ summarizeData.last_money | money }}</p>
              </div>
            </li>

            <!-- <li>
              <div class="summaryTitle">
                未结清
                <el-popover
                  placement="top-start"
                  class="tip_mr"
                  trigger="click"
                >
                  内容待定中...
                  <img src="../../assets/images/tip.png" slot="reference" />
                </el-popover>
              </div>
              <div class="uncleared summaryLine">
                <p>¥ 1,210,858</p>
                1669瓶
              </div>
            </li> -->
          </ul>
        </div>
        <div style="height: 20px"></div>
      </template>
      <template v-slot:last_money="row">
        <template v-if="row.row.last_money > 0">
          <el-link type="danger">{{ row.row.last_money | money }}</el-link>
        </template>
        <template v-else>
          {{ row.row.last_money | money }}
        </template>
      </template>
      <template v-slot:operation="row">
        <div style="display: flex; align-items: center">
          <template
            v-if="
              hasPermission('采购-采购单-编辑') &&
              (row.row.status == 1 || row.row.status == 2)
            "
          >
            <div class="button button_modify" @click="editButton(row.row)">
              <i class="iconfont icon-bianji"></i> 编辑
            </div>
          </template>
          <template v-else>
            <div class="button button_modify" @click="preview(row.row)">
              <i class="iconfont icon-yulanmoban"></i> 查看
            </div>
          </template>

          <el-popover
            :visible-arrow="false"
            placement="bottom"
            width="80"
            trigger="click"
          >
            <ul class="moreOperations">
              <li
                v-if="row.row.last_money > 0 && row.row.status != 2"
                @click="shoudPayButton(row.row)"
              >
                <i class="iconfont icon-jiezhang"></i> 付款
              </li>
              <li
                v-if="
                  hasPermission('采购-采购单-删除') &&
                  (row.row.status == 1 || row.row.status == 2)
                "
                @click="deleteRows(row.row)"
              >
                <i class="iconfont icon-shanchu"></i> 删除
              </li>

              <li
                v-if="
                  row.row.payed_money == 0 &&
                  row.row.pre_money == 0 &&
                  row.row.status == 0 &&
                  row.row.create_date == new Date().toISOString().slice(0, 10)
                "
                @click="checkout(row.row)"
              >
                <i class="iconfont icon-chehui03"></i> 撤回
              </li>
              <li v-if="row.row.status != 2" @click="sourceTracing(row.row)">
                <i class="iconfont el-icon-warning-outline"></i> 溯源
              </li>
              <li @click="freight(row.row, 'out')">
                <i class="iconfont el-icon-truck"></i> 运出
              </li>
              <li @click="printSettings(row.row)">
                <i class="iconfont icon-dayin"></i> 打印
              </li>
            </ul>
            <div slot="reference" class="button button_more">
              <img src="../../assets/images/icon_more.png" />
            </div>
          </el-popover>
        </div>
      </template>
    </basicList>
    <formWindow
      :dialogParams="dialogParams"
      @close="closeThePopUpWindow"
    ></formWindow>
    <Freigth :config="freightConfig" @close="closefreightConfig"></Freigth>
    <previewComponents
      @close="closeView"
      :acceptedParameters="previewParams"
      @refresh="refresh"
    ></previewComponents>
    <!-- <sourceList
      v-if="sourceTracingParams.visible"
      :dialogParams="sourceTracingParams"
      @close="handleSourceTracingClose"
    ></sourceList> -->
    <sourceTracing
      v-if="sourceTracingParams.visible"
      :dialogParams="sourceTracingParams"
      @close="handleSourceTracingClose"
    ></sourceTracing>
    <!-- 打印设置 -->
    <el-dialog
      :title="printTitle"
      :visible.sync="printSettingsVisible"
      custom-class="addProductPopUpWindow"
      width="600px"
      append-to-body
    >
      <el-checkbox-group v-model="checkList">
        <div v-for="(item, index) in printingParameters" :key="index">
          <el-row :gutter="20">
            <div v-for="list in item" :key="list">
              <el-col :span="8">
                <el-checkbox :label="list"></el-checkbox>
                <div style="height: 15px"></div>
              </el-col>
            </div>
          </el-row>
        </div>
      </el-checkbox-group>
      <div slot="footer">
        <el-button @click="cancel">取消</el-button>
        <el-button type="primary" @click="confirmPrinting">确定</el-button>
      </div>
    </el-dialog>

    <!-- 打印组件 -->
    <printingComponents
      @close="closePrinting"
      :acceptedParameters="printingParameter"
      @refresh="refreshPrinting"
    ></printingComponents>

    <checkoutComponent
      :dialogParams="shoudPayParams"
      @close="closeThePopUpWindow2"
    ></checkoutComponent>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import {
  orderBuyGetList,
  orderBuyDel,
  orderBuyUnDo,
  getOrderAllInfo,
  orderBuyGetOne,
} from "@/api/purchasing";
import {
  getshoplist,
  supplierGetList,
  userPermissionShopGetList,
  userPermissionSupplierGetList,
  userGetlist,
} from "@/api/basicConfiguration";
import { getRoles } from "@/utils";
// 默认参数
const defaultParameters = {
  page: 1,
  limit: 10,
};
export default {
  name: "purchaseOrder",
  components: {
    formWindow: () => import("./formWindow.vue"),
    previewComponents: () => import("@/components/previewComponents"),
    //  sourceList: () => import("@/views/productTraceability/sourceList.vue"),
    sourceTracing: () =>
      import("@/views/productTraceability/sourceTracing.vue"),
    Freigth: () => import("./freigth.vue"),
    checkoutComponent: () => import("@/components/checkoutComponent"),
    printingComponents: () => import("@/components/printingComponents"),
  },
  data() {
    return {
      printingParameter: {
        key: new Date().getTime(),
        visible: false,
        type: "saleOrder",
        viewObj: [],
        code: "",
      },
      // 打印参数
      printTitle: "",
      printSettingsVisible: false,
      printingParameters: [
        [
          "供应商",
          "联系电话",
          "制单人",
          "采购门店",
          "采购人",
          "采购日期",
          "备注",
        ],

        ["商品金额", "运费金额", "订单总金额", "余额抵扣", "应付总金额", "商品总数"],
        ["付款明细", "物流码"],
      ],
      checkList: [
        "供应商",
        "采购门店",
        "联系电话",
        "采购日期",
        "采购人",
        "制单人",
        "备注",
        "订单总金额",
        "物流码",
      ],
      // 溯源弹窗
      sourceTracingParams: {
        key: new Date().getTime(),
        visible: false,
        id: "",
      },
      compId: null,
      userId: null,
      roleId: null,
      comp_level: null,
      shopIds: [], // 权限管理中允许用户使用的店铺，高级角色看所有店铺

      // 弹窗参数
      dialogParams: {
        key: new Date().getTime(),
        visible: false,
        id: "",
      },
      shoudPayParams: {
        key: new Date().getTime(),
        visible: false,
        id: "",
        code: "",
      },
      previewParams: {
        key: new Date().getTime(),
        visible: false,
        type: "purchaseOrder",
        code: "",
        viewObj: [],
      },
      // 溯源列表
      traceabilityDialogParams: {
        key: new Date().getTime(),
        visible: false,
        id: "",
      },
      // 列表组件参数
      basicListconfig: {
        loading: false,
        operationWidth: 140,
        search: [
          {
            label: "门店",
            type: "select",
            options: [],
            key: "shop_id",
          },
          {
            label: "供应商",
            type: "select",
            options: [],
            key: "supplier_id",
          },
          {
            label: "单号",
            type: "input",
            key: "form_sn",
          },
          {
            label: "创建时间",
            type: "daterange",
            key: "create_time",
          },
          {
            label: "状态",
            type: "select",
            options: [
              {
                label: "正常",
                value: 0,
              },
              {
                label: "取消",
                value: 2,
              },
            ],
            key: "status",
          },
          {
            label: "业务员",
            type: "select",
            options: [],
            key: "user_id",
          },
        ],
        data: [],
        column: [
          {
            label: "编号",
            prop: "id",
            sortable: true,
            width: 100,
          },
          // {
          //   label: "日期",
          //   prop: "create_date",
          //   sortable: true,
          //   width: 120,
          // },
          {
            label: "开单时间",
            prop: "create_time",
            sortable: true,
            width: 200,
          },
          {
            label: "供应商",
            prop: "supplier_name",
            width: 180,
          },
          {
            label: "门店",
            prop: "shop_name",
            width: 180,
          },
          {
            label: "数量",
            prop: "num",
            sortable: true,
            width: 120,
          },
          {
            label: "订单金额",
            prop: "total_money",
            isMoney: true,
            sortable: true,
            width: 150,
          },
          {
            label: "运费",
            prop: "trans_money",
            sortable: true,
            isMoney: true,
            width: 150,
          },
          {
            label: "未付",
            prop: "last_money",
            slot: true,
            sortable: true,
            width: 150,
          },
          {
            label: "业务员",
            prop: "customer_name",
            width: 150,
          },
          {
            label: "入库人",
            prop: "user_name",
            width: 150,
          },
          {
            label: "备注",
            prop: "remark",
            width: 200,
          },

          {
            label: "采购单号",
            prop: "form_sn",
            width: 250,
          },
          {
            label: "状态",
            prop: "status",
            filter: "documentStatus",
          },
        ],
        isPage: true,
        total: 0,
        searchParameters: Object.assign({}, defaultParameters),
      },
      summarizeData: {},
      temporaryRowData: {},
      freightConfig: {
        visible: false,
        key: new Date().getTime(),

        data: {
          shop_id: "",
          money: "",
          id: "",
          part_id: "",
          from_sn: "",
          comp_id: "",
        },
      },
    };
  },
  created() {
    this.compId = this.$store.getters.userInfo.compId;
    this.userId = this.$store.getters.userInfo.userId;
    this.roleId = this.$store.getters.userInfo.roleId;
    this.comp_level = this.$store.getters.userInfo.comp_level;
    // this.obtainStatisticalSummary();
    // 初始化列表内容
    this.obtainDataSource().then(() => {
      if (this.roleId == 4) {
        this.basicListconfig.searchParameters.shop_id =
          this.$store.getters.userInfo.shopId;
      }
      this.getlist(); // 先拿基础数据，在拉记录
    });
  },
  computed: {
    ...mapGetters(["hasPermission", "getPermissionId"]),
  },
  methods: {
    isItDisplayed(name) {
      return this.checkList.includes(name);
    },
    confirmPrinting() {
      const row = this.temporaryRowData;
      this.printingParameter.code = row.form_sn;
      this.printingParameter.documentName = "采购码";
      this.printingParameter.isShowCode = !this.isItDisplayed("物流码");
      orderBuyGetOne({ form_sn: row.form_sn }).then((res) => {
        if (res.code == 1) {
          let payData = res.$pay_list.map((item) => {
            item.pay_price = this.$money(item.pay_price);
            item.all_price = this.$money(item.all_price);
            item.last_price = this.$money(item.last_price);
            return item;
          });
          if (res.item_way.length > 0) {
            this.printingParameter.traceabilityId = res.item_way[0].id;
          } else {
            this.printingParameter.traceabilityId = "*";
          }

          let data = res.$order_list.map((item) => {
            item.name = item.item_info.name + "(1*" + item.in_package_num + ")";
            item.type_spec = item.item_info.type_spec;
            item.price_distribution = this.$money(item.price_distribution);
            item.need_item_stock_single = item.single_num;
            item.need_item_stock_package = item.package_num;
            item.total_money = this.$money(item.total_money);
            item.price_oneBox = (
              Number(item.price_distribution) * Number(item.in_package_num)
            ).toFixed(2);
            item.need_item_stock_total = (
              Number(item.need_item_stock_single) +
              Number(item.need_item_stock_package) * Number(item.in_package_num)
            ).toFixed(2);
            item.algorithm =
              item.price_distribution +
              "*" +
              "(" +
              item.need_item_stock_single +
              "+" +
              item.need_item_stock_package +
              "*" +
              item.in_package_num +
              ") = " +
              item.total_money;
            return item;
          });
          this.printingParameter.viewObj = [
            {
              title: "",
              type: "object",
              value: [
                {
                  label: "供应商",
                  value: res.order_info.supplier_name,
                  show: !this.isItDisplayed("供应商"),
                },
                {
                  label: "联系电话",
                  value: res.order_info.supplier_tel,
                  show: !this.isItDisplayed("联系电话"),
                },
                {
                  label: "制单人",
                  value: res.order_info.user_name,
                  show: !this.isItDisplayed("制单人"),
                },
                {
                  label: "采购门店",
                  value: res.order_info.shop_name,
                  show: !this.isItDisplayed("采购门店"),
                },
                {
                  label: "采购人",
                  value: res.order_info.customer_name,
                  show: !this.isItDisplayed("采购人"),
                },
                {
                  label: "采购日期",
                  value: res.order_info.create_time,
                  show: !this.isItDisplayed("采购日期"),
                },
                {
                  label: "备注",
                  value: res.order_info.remark,
                  show: !this.isItDisplayed("备注"),
                },
              ],
            },
            {
              title: "采购明细",
              type: "array",
              value: data,
              column: [
                {
                  label: "商品名称",
                  prop: "name",
                },
                {
                  label: "单位",
                  prop: "type_spec",
                },
                {
                  label: "单价",
                  prop: "price_distribution",
                },
                {
                  label: "数量",
                  prop: "num",
                },
                {
                  label: "小计",
                  prop: "total_money",
                },
              ],
            },
            {
              title: "",
              type: "object",
              show: !(
                this.isItDisplayed("商品金额") ||
                this.isItDisplayed("运费金额") ||
                this.isItDisplayed("订单总金额") ||
                this.isItDisplayed("余额抵扣") ||
                this.isItDisplayed("应付总金额")
              ),
              value: [
                {
                  label: "商品金额",
                  value: this.$money(res.order_info.item_money),
                  show: !this.isItDisplayed("商品金额"),
                },
                {
                  label: "运费金额",
                  value: this.$money(res.order_info.trans_money),
                  show: !this.isItDisplayed("运费金额"),
                },
                {
                  label: "订单总金额",
                  value: this.$money(res.order_info.total_money),
                  show: !this.isItDisplayed("订单总金额"),
                },
                {
                  label: "余额抵扣",
                  value: this.$money(res.order_info.pre_money),
                  show: !this.isItDisplayed("余额抵扣"),
                },
                {
                  label: "应付总金额",
                  value: this.$money(
                    Number(res.order_info.total_money) -
                      Number(res.order_info.pre_money)
                  ),
                  show: !this.isItDisplayed("应付总金额"),
                },
                {
                  label: "商品总数",
                  value: res.order_info.num,
                  show: !this.isItDisplayed("商品总数"),
                },
              ],
            },
            {
              title: "付款明细",
              show: !this.isItDisplayed("付款明细"),
              type: "array",
              value: payData,
              column: [
                {
                  label: "付款账户",
                  prop: "account_name",
                },
                {
                  label: "付款",
                  prop: "all_price",
                },
                {
                  label: "时间",
                  width: "40%",
                  prop: "create_time",
                },
              ],
            },
            {
              title: "",
              type: "object",
              show: !this.isItDisplayed("付款明细"),
              value: [
                {
                  label: "已付金额",
                  value: this.$money(res.order_info.payed_money),
                  show: !this.isItDisplayed("付款明细"),
                },
                {
                  label: "未付金额",
                  value: this.$money(res.order_info.last_money),
                  show: !this.isItDisplayed("付款明细"),
                },
              ],
            },
            // {
            //   title: "条码",
            //   type: "object",
            //   show: !this.isItDisplayed("条码"),
            //   value: [
            //     {
            //       label: "",
            //       value: item_way,
            //       show: !this.isItDisplayed("条码"),
            //     },
            //   ],
            // },
          ];

          this.printingParameter.key = new Date().getTime();
          this.printingParameter.visible = true;
          this.printingParameter.type = "sale";
        } else {
          this.$message.error("获取详情失败");
        }
      });
    },
    cancel() {
      this.printSettingsVisible = false;
    },
    // 打印参数设置
    printSettings(row) {
      this.temporaryRowData = row;
      this.printTitle = "单据号:" + row.form_sn + "打印设置";
      this.printSettingsVisible = true;
    },
    sortChange(data) {
      this.basicListconfig.searchParameters.page = 1;
      this.basicListconfig.searchParameters.order_column = data.prop;
      this.basicListconfig.searchParameters.order_up =
        data.order == "ascending" ? 1 : data.order == "descending" ? 0 : "";
      this.getlist();
    },
    refresh() {
      this.preview(this.temporaryRowData);
    },
    // 获取统计汇总
    obtainStatisticalSummary(obj) {
      let data = {
        shop_id: obj.shop_id,
        supplier_id: obj.supplier_id,
        form_sn: obj.form_sn,
        status: obj.status,
        comp_id: JSON.parse(getRoles()).comp_id,
        // begin_at: this.$getCurrent(1),
        begin_time: obj.begin_time,
        end_time: obj.end_time,
      };
      getOrderAllInfo(data).then((res) => {
        if (res.code == 1) {
          this.summarizeData = res.query_res;
        } else {
          this.$message.error(res.data.msg || "获取失败");
        }
      });
    },
    closePrinting() {
      this.printingParameter.key = new Date().getTime();
      this.printingParameter.visible = false;
    },
    refreshPrinting() {
      this.preview(this.temporaryRowData, "printingParameter");
    },
    sourceTracing(row) {
      if (!row.item_way) {
        row.item_way = {
          pics: "",
        };
      }
      this.sourceTracingParams.key = new Date().getTime(); //  row.id; // new
      this.sourceTracingParams.visible = true;
      this.sourceTracingParams.form_sn = row.form_sn;
      this.sourceTracingParams.memberId = row.supplier_id;
      this.sourceTracingParams.memberName =
        row.supplier_id + "-" + row.supplier_name;
      this.sourceTracingParams.item_way_num = row.item_way_num;
      this.sourceTracingParams.flow_type = -1;
      this.sourceTracingParams.item_way_data = row;
    },
    closefreightConfig() {
      this.freightConfig.visible = false;
      this.freightConfig.key = new Date().getTime();
      this.getlist();
      this.getlistyu();
    },
    freight(row, type) {
      this.freightConfig.key = new Date().getTime();
      this.freightConfig.visible = true;
      this.freightConfig.data.money = this.$money(row.trans_money);
      this.freightConfig.data.from_sn = row.form_sn;
      this.freightConfig.data.shop_id = row.shop_id;
      this.freightConfig.data.user_id = JSON.parse(getRoles()).user_id;
      this.freightConfig.data.customer_id = 0;
      this.freightConfig.data.supplier_id = row.supplier_id;
      this.freightConfig.data.part_id = JSON.parse(getRoles()).part_id;
      this.freightConfig.data.id = "";
      this.freightConfig.data.comp_id = row.comp_id;
      this.freightConfig.data.remark = "运费额外支出";
      this.freightConfig.data.type = type;
    },
    handleSourceTracingClose(val) {
      this.sourceTracingParams.visible = false;
      this.sourceTracingParams.form_sn = "";
      this.sourceTracingParams.id = 0;
      this.sourceTracingParams.key = "";
      this.sourceTracingParams.flow_type = -1;
      if (val == 1) {
        this.getlist();
      }
    },
    // 关闭查看
    closeView() {
      this.previewParams.key = new Date().getTime();
      this.previewParams.visible = false;
    },
    preview(row) {
      this.temporaryRowData = row;
      this.previewParams.code = row.form_sn;
      orderBuyGetOne({ form_sn: row.form_sn }).then((res) => {
        if (res.code == 1) {
          let payData = res.$pay_list.map((item) => {
            item.pay_price = this.$money(item.pay_price);
            item.all_price = this.$money(item.all_price);
            item.last_price = this.$money(item.last_price);
            return item;
          });
          let item_way = res.item_way.map((item) => {
            if (item.pics) item.pics = item.pics.split(",");
            return item;
          });
          let data = res.$order_list.map((item) => {
            item.name =
              item.item_info.name + "(1*" + item.item_info.in_package_num + ")";
            item.price_distribution = this.$money(item.price_distribution);
            item.need_item_stock_single = item.single_num;
            item.need_item_stock_package = item.package_num;
            item.total_money = this.$money(item.total_money);
            item.price_oneBox = (
              Number(item.price_distribution) * Number(item.in_package_num)
            ).toFixed(2);
            item.need_item_stock_total = (
              Number(item.need_item_stock_single) +
              Number(item.need_item_stock_package) * Number(item.in_package_num)
            ).toFixed(0);
            item.algorithm =
              item.price_distribution +
              "*" +
              "(" +
              item.need_item_stock_single +
              "+" +
              item.need_item_stock_package +
              "*" +
              item.in_package_num +
              ") = " +
              item.total_money;
            return item;
          });
          this.previewParams.viewObj = [
            {
              title: "",
              type: "object",
              value: [
                {
                  label: "供应商",
                  value: res.order_info.supplier_name,
                },
                {
                  label: "采购门店",
                  value: res.order_info.shop_name,
                },
                {
                  label: "采购人",
                  value: res.order_info.customer_name,
                },
                {
                  label: "制单人",
                  value: res.order_info.user_name,
                },
                {
                  label: "备注",
                  value: res.order_info.remark,
                },
              ],
            },
            {
              title: "采购明细",
              type: "array",
              value: data,
              column: [
                {
                  label: "商品名称",
                  prop: "name",
                },
                {
                  label: "单价",
                  prop: "price_distribution",
                },
                {
                  label: "采购数量",
                  prop: "num",
                  align: "center",
                  // children: [
                  //   {
                  //     label: "散",
                  //     prop: "need_item_stock_single",
                  //     width: 100,
                  //     align: "center",
                  //   },
                  //   {
                  //     label: "箱",
                  //     prop: "need_item_stock_package",
                  //     width: 100,
                  //     align: "center",
                  //   },
                  //   {
                  //     label: "总",
                  //     prop: "need_item_stock_total",
                  //     width: 100,
                  //     align: "center",
                  //   },
                  // ],
                },
                {
                  label: "小计",
                  prop: "total_money",
                  width: 200,
                },
              ],
            },
            {
              title: "采购金额",
              type: "object",
              value: [
                {
                  label: "商品金额",
                  value: this.$money(res.order_info.item_money),
                },
                {
                  label: "运费金额",
                  value: this.$money(res.order_info.trans_money),
                },
                {
                  label: "订单总金额",
                  value: this.$money(res.order_info.total_money),
                },
                {
                  label: "余额抵扣",
                  value: this.$money(res.order_info.pre_money),
                },
                {
                  label: "应付总金额",
                  value: this.$money(
                    Number(res.order_info.total_money) -
                      Number(res.order_info.pre_money)
                  ),
                },
                {
                  label: "商品总数",
                  value: res.order_info.num,
                },
              ],
            },
            {
              title: "付款信息",
              type: "array",
              value: payData,
              column: [
                {
                  label: "付款账户",
                  prop: "account_name",
                },
                {
                  label: "付款",
                  prop: "all_price",
                },
                {
                  label: "结款",
                  prop: "pay_price",
                },
                {
                  label: "余款",
                  prop: "last_price",
                },
                {
                  label: "时间",
                  prop: "create_time",
                },
                {
                  label: "类型",
                  prop: "pay_type",
                },
                {
                  label: "操作",
                  prop: "operation",
                },
              ],
            },
            {
              title: "",
              type: "object",
              value: [
                {
                  label: "已付金额",
                  value: this.$money(res.order_info.payed_money),
                },
                {
                  label: "未付金额",
                  value: this.$money(res.order_info.last_money),
                },
              ],
            },
            {
              title: "溯源信息",
              type: "array",
              value: item_way,
              column: [
                {
                  label: "ID",
                  prop: "id",
                  width: 80,
                },
                {
                  label: "溯源码",
                  prop: "code_value",
                },
                // {
                //   label: "品名",
                //   prop: "item_name",
                // },
                // {
                //   label: "会员号",
                //   prop: "supplier_id",
                // },
                {
                  label: "操作人",
                  prop: "user_name",
                  width: 100,
                },
                {
                  label: "溯源照片",
                  prop: "pics",
                  width: 200,
                },
                {
                  label: "更新时间",
                  prop: "update_time",
                  width: 100,
                },
              ],
            },
          ];

          this.previewParams.key = new Date().getTime();
          this.previewParams.visible = true;
        } else {
          this.$message.error("获取详情失败");
        }
      });
    },
    checkout(row) {
      this.$confirm("是否确定撤回该单据?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        orderBuyUnDo({ id: row.id }).then((res) => {
          if (res.code == 1) {
            this.$message.success("撤回成功");
            this.getlist();
          } else {
            this.$message.error(res.data.msg || "撤回失败");
          }
        });
      });
    },
    print() {
      this.$message.success("开发中...");
    },
    // 删除方法
    deleteRows(row) {
      this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        orderBuyDel({ id: row.id }).then((res) => {
          if (res.code == 1) {
            this.$message.success("删除成功");
            this.getlist();
          } else {
            this.$message.error(res.data.msg);
          }
        });
      });
    },
    // 关闭弹窗
    closeThePopUpWindow() {
      this.dialogParams.visible = false;
      this.dialogParams.key = new Date().getTime();
      this.getlist();
    },
    closeThePopUpWindow2() {
      this.shoudPayParams.visible = false;
      this.shoudPayParams.key = new Date().getTime();
      this.getlist();
    },
    // 编辑弹窗
    editButton(row) {
      this.dialogParams.key = new Date().getTime();
      this.dialogParams.visible = true;
      this.dialogParams.id = row.form_sn;
    },
    // 编辑合并付款弹窗
    shoudPayButton(row) {
      this.shoudPayParams.key = new Date().getTime();
      this.shoudPayParams.visible = true;
      this.shoudPayParams.form_sn = row.form_sn;
      this.shoudPayParams.type = 2;
      this.shoudPayParams.unpaidAmount = this.$money(row.last_money);
    },
    // 新增事件
    newlyAdded() {
      this.dialogParams.key = new Date().getTime();
      this.dialogParams.visible = true;
      this.dialogParams.id = "";
    },
    // 搜索事件
    searchEvent(data, page, pageSize) {
      if (page || pageSize) {
        if (page) this.basicListconfig.page = page;
        if (pageSize) this.basicListconfig.searchParameters.limit = pageSize;
        this.getlist();
      } else if (data) {
        for (const key in data) {
          if (Array.isArray(data[key])) {
            if (data[key].length == 0) {
              delete this.basicListconfig.searchParameters.begin_time;
              delete this.basicListconfig.searchParameters.end_time;
            } else {
              this.basicListconfig.searchParameters.begin_time = data[key][0];
              this.basicListconfig.searchParameters.end_time = data[key][1];
            }
          }
          this.basicListconfig.searchParameters[key] = data[key];
        }

        this.basicListconfig.searchParameters.page = 1;
        this.getlist();
      }
    },
    // 获取列表内容
    getlist() {
      // 有用户门店权限的，查看只能看指定门店记录
      // 用户选中店铺时，按所选店铺查看; 未选时，按用户权限所有店面查询
      if (!this.basicListconfig.searchParameters["shop_id"]) {
        if (this.shopIds.length != 0) {
          this.basicListconfig.searchParameters["shop_id"] =
            this.shopIds.join(", ");
        }
      }
      this.obtainStatisticalSummary(this.basicListconfig.searchParameters);
      this.basicListconfig.loading = true;
      orderBuyGetList(this.basicListconfig.searchParameters).then((res) => {
        if (res.code == 1) {
          this.basicListconfig.loading = false;
          this.basicListconfig.data = res.data.map((item) => {
            item.supplier_name =
              item.supplier_id +
              "-" +
              item.supplier_name +
              (item.supplier_nickname
                ? "(" + item.supplier_nickname + ")"
                : "");
            return item;
          });
          this.basicListconfig.total = res.count;
        } else {
          this.basicListconfig.loading = false;
          this.$message.error(res.msg);
        }
      });
    },
    // 获取门店列表, 获取供应商列表
    obtainDataSource() {
      userGetlist({ limit: 10000, status: 0 }).then((res) => {
        if (res.code == 1) {
          this.basicListconfig.search.map((item) => {
            if (item.key == "user_id") {
              item.options = res.data.map((item) => {
                return {
                  label: item.name,
                  value: item.id,
                };
              });
            }
            return item;
          });
        } else {
          this.$message.error(res.data.msg || "获取供应商数据源失败！");
        }
      });
      return Promise.all([this.getShops(), this.getSupplier()]);
    },

    //  依据角色与权限拉供应商
    getSupplier() {
      if (this.roleId == 4) {
        return userPermissionSupplierGetList({
          limit: 10000,
          status: 0,
          comp_id: this.compId,
        }).then((res) => {
          if (res.code == 1) {
            this.basicListconfig.search.map((item) => {
              if (item.key == "supplier_id") {
                item.options = res.data.map((item) => {
                  return {
                    label: item.id + "-" + item.nick_name,
                    value: item.id,
                  };
                });
              }
            });
          } else {
            this.$message.error(res.data.msg || "获取供应商数据源失败！");
          }
        });
      } else {
        return supplierGetList({
          limit: 10000,
          status: 0,
          comp_id: this.compId,
        }).then((res) => {
          if (res.code == 1) {
            this.basicListconfig.search.map((item) => {
              if (item.key == "supplier_id") {
                item.options = res.data.map((item) => {
                  return {
                    label: item.id + "-" + item.nick_name,
                    value: item.id,
                  };
                });
              }
            });
          } else {
            this.$message.error(res.data.msg || "获取供应商数据源失败！");
          }
        });
      }
    },

    // 依据角色与权限拉门店表
    getShops() {
      if (this.roleId == 4) {
        return userPermissionShopGetList({
          comp_id: this.compId,
          user_id: this.userId,
          permission_id: this.getPermissionId("采购-采购单-查看"),
        }).then((res) => {
          if (res.code == 1) {
            this.shopIds = res.data.map((item) => item.id);
            this.basicListconfig.search.map((item) => {
              if (item.key == "shop_id") {
                item.options = res.data.map((item) => {
                  return {
                    label: item.name,
                    value: item.id,
                  };
                });
              }
            });
          } else {
            this.$message.error(res.data.msg || "获取门店数据源失败！");
          }
        });

        // 高级别所看门店不受控制
      } else {
        return getshoplist({
          limit: 10000,
          status: 0,
          comp_id: this.compId,
        }).then((res) => {
          if (res.code == 1) {
            this.shopIds = res.data.map((item) => item.id);
            this.basicListconfig.search.map((item) => {
              if (item.key == "shop_id") {
                item.options = res.data.map((item) => {
                  return {
                    label: item.name,
                    value: item.id,
                  };
                });
              }
            });
          } else {
            this.$message.error(res.data.msg || "获取门店数据源失败！");
          }
        });
      }
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/purchaseOrder/index.vue